export function extractNumberFromSizeInPixels(sizeInPixels) {
  var numberValue = Number(sizeInPixels.replace('px', ''));
  if (isNaN(numberValue)) throw new Error("".concat(sizeInPixels, " is not a valid size in pixels"));
  return numberValue;
}